export const getBreadCrumb = (page, river, name) => {
  const route = useRoute()
  switch (page) {
    case 'top': {
      return [
        { text: '河川水位情報' }
      ]
    }
    case 'river': {
      return [
        { text: '河川水位情報', link: '/onebox/river/' },
        { text: river }
      ]
    }
    case 'point': {
      if (!route.params.river || !river) {
        return [
          { text: '河川水位情報', link: '/onebox/river/' },
          { text: name }
        ]
      }
      return [
        { text: '河川水位情報', link: '/onebox/river/' },
        { text: river, link: `/onebox/river/${route.params.river}/` },
        { text: name }
      ]
    }
  // No default
  }
}
